/* Recheck the current page height instead of the app's initial scroll snapshot. */
(() => {
  const popupId = 106120;
  const chatOpen = () => document.documentElement.dataset.dutChatOpen === 'true' || !!document.querySelector('#tai-dialog[open]');
  const dismissed = new WeakSet();
  const dismissDuringChat = () => {
    if (!chatOpen()) return;
    document.querySelectorAll('.react-responsive-modal-root:has(.ecomsend__Modal__Content)').forEach(root => {
      if (dismissed.has(root)) return;
      const close = root.querySelector('.ecomsend__Modal__CloseButton');
      if (close) { dismissed.add(root); close.click(); }
    });
  };
  document.addEventListener('dut-concierge-state', dismissDuringChat);
  new MutationObserver(dismissDuringChat).observe(document.body, {childList:true, subtree:true});
  let attempts = 0, guarded = false;
  const install = setInterval(() => {
    const actions = window.EcomSendApps?.actions;
    if (actions?.showModal && !guarded) {
      const originalShow = actions.showModal;
      actions.showModal = function (...args) {
        if (chatOpen()) return;
        return originalShow.apply(this, args);
      };
      guarded = true;
      dismissDuringChat();
    }
    const config = actions?.getTargetPopupConfig?.(popupId);
    if (!config) {
      if (++attempts >= 300) clearInterval(install);
      return;
    }
    clearInterval(install);
    if (config.rules?.trigger?.when?.type !== 2) return;
    const halfway = () => {
      const distance = document.documentElement.scrollHeight - window.innerHeight;
      return distance > 0 && window.scrollY >= distance * .5;
    };
    const original = actions.showModal;
    actions.showModal = function (manual, preview, id, skipScroll) {
      if (String(id) === String(popupId) && !manual && !preview) {
        if (!halfway()) return;
        skipScroll = true;
      }
      return original.call(this, manual, preview, id, skipScroll);
    };
    let attempted = false;
    const check = () => {
      if (attempted || chatOpen() || !halfway()) return;
      attempted = true;
      window.removeEventListener('scroll', check);
      // App entry point retains targeting, dismissal, subscription and frequency checks.
      actions.initPopup(popupId);
    };
    window.addEventListener('scroll', check, { passive: true });
    document.addEventListener('dut-concierge-state', () => { if (!chatOpen()) setTimeout(check, 1500); });
    check();
  }, 100);
})();
